import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import Config from '../../../../../Config';
import { reportDWH } from '../../EsimQrCodeBlockSlice';
import { gtag4 } from '../../../../../utilities/analytics/tracking';
import success from './images/success.svg';

const WhatsAppSuccessPage = (props) => {

    useEffect(() => {
        gtag4({ event: 'EsimLine_IndicationWhatsappError', step: '1', action: 'IndicationWhatsappError' });
        props.reportDWH({ actionType: 'Activaion Page - QR', status: 'Ongoing', messageText: 'Whatspapp Will Open Soon Notifcaion - Display' });
    }, []);

    return (
        <div className='whatsapp-success-page-wrapper'>
            <div className='whatsapp-success-page'>

                <div className='success-icon' style={{backgroundImage:success.bg()}}></div>
                <div className='title'> מעולה! <br />
                    בעוד רגע נשלח הודעה <br />
                    ב-WhatsApp לנייד {props.subscriberNo}
                </div>

                <div className='button-wrapper'>
                    <BtnWhiteBlackBorderBigSize
                        isBusiness={false}
                        text='לאזור האישי'
                        onclick={handlePageContinue}
                        formid='esim-block'
                        isDisplayArrows={false}
                        isDisplayWhatsAppIcon={false}
                    />
                </div>

            </div>
        </div>
    );

    function handlePageContinue() {
        //gtag4({ event: 'EsimUpgrade_Step4_SuccessActivateButton', step: '4', action: 'SuccessActivateButton' });
        //props.reportDWH({ actionType: 'Activaion Page - QR', status: 'Ongoing', messageText: 'Whatspapp Will Open Soon Notifcaion - Display' });
        buildUrlAndOpenSameWindow(Config.lobbyUrl);
    }

};

const mapStateToProps = (state) => {
    return {
        subscriberNo: state.esimQrCodeBlock.loginDetails.subscriberNo
    };
};

const mapDispatchToProps = {
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatsAppSuccessPage);
